import React from 'react';
import { CHECKOUT_URL, CTA_LABEL } from '../data/landing';
type CtaButtonProps = {
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  label?: string;
  subLabel?: string;
};
export function CtaButton({
  size = 'md',
  fullWidth = false,
  label = CTA_LABEL,
  subLabel
}: CtaButtonProps) {
  const pad = size === 'lg' ? 'px-8 py-5 text-lg' : 'px-6 py-4 text-base';
  return <div className={fullWidth ? 'w-full' : 'inline-block'} data-id="element-13" data-mp="qkk7ivo9ff0n">
      <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex ${fullWidth ? 'w-full' : ''} items-center justify-center gap-3 rounded-full bg-tomato ${pad} font-sans font-bold uppercase tracking-wide text-white shadow-lift transition-[transform,background-color] duration-150 ease-soft hover:-translate-y-0.5 hover:bg-tomato-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-tomato active:translate-y-0`} data-id="element-14" data-mp="qizbt2q7lq17">
        <span className="text-center leading-tight" data-id="element-15" data-mp="35x5vvcntqm1f">{label}</span>
      </a>
      {subLabel ? <p className="mt-3 text-center font-sans text-sm text-muted" data-id="element-16" data-mp="35zijo6g9jqme">{subLabel}</p> : null}
    </div>;
}